import { render, staticRenderFns } from "./otherCollectionItemsDetailNew.vue?vue&type=template&id=30f4e57c&scoped=true"
import script from "./otherCollectionItemsDetailNew.vue?vue&type=script&lang=js"
export * from "./otherCollectionItemsDetailNew.vue?vue&type=script&lang=js"
import style0 from "./otherCollectionItemsDetailNew.vue?vue&type=style&index=0&id=30f4e57c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f4e57c",
  null
  
)

export default component.exports